<template>
    <div class="wxpay-content">
        <van-cell-group>
            <template #title>
                <div class="title">
                    <div class="title-box">微信提现信息</div>
                    <div class="title-box">
                        <van-radio-group v-model="radioValue">
                            <van-radio :name="1" @click="setDefault">设为默认</van-radio>
                        </van-radio-group>
                    </div>
                </div>
            </template>
            <van-field v-model="wxpay.name" label="姓名" placeholder="请输入微信绑定姓名" required :error-message="nameErrMsg"
                @focus="inputFocus" />
        </van-cell-group>
        <div class="form-btn">
            <van-button block type="warning" @click="saveHandler">保 存</van-button>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { updateWxpayAccountApi } from 'api/submit'

export default {
    data() {
        return {
            radioValue: 0,
            isDefault: false,
            wxpay: {
                id: '',
                name: ''
            },
            nameErrMsg: '',
            deleteBtnDisabled: false
        }
    },
    mounted() {
        this.wxpay.id = this.$route.query.bankId
        this.wxpay.name = this.$route.query.accountHolder
        this.radioValue = this.$route.query.isDefault
    },
    methods: {
        setDefault() {
            if (!this.isDefault) {
                this.isDefault = true
            } else {
                this.radioValue = 0
                this.isDefault = false
            }
        },
        saveHandler() {
            this.updateWxpayAccount()
        },
        updateWxpayAccount() {
            if (!this.validator()) return
            console.log('updatewxpayAccount')
            let data = { ...this.wxpay, isDefault: this.radioValue }
            updateWxpayAccountApi(data).then(({ status, message}) => {
                if (status === 200) {
                    Toast('保存成功')
                    this.$back(-1)
                }
                else if (status === 400) {
                    this.$toast(message)
                } else {
                    this.$toast('网络异常，请稍后再试')
                }
            })
        },
        validator() {
            if (this.wxpay.name.length === 0) {
                this.nameErrMsg = '请输入姓名'
                return false
            }
            return true
        },
        inputFocus() {
            this.nameErrMsg = ''
        }
    }
}
</script>
<style lang="css" scoped>
.wxpay-content {
    padding: 10px;
}

.title {
    display: flex;
    justify-content: space-between;
}

.title-box {
    display: inline-block;
}

.form-btn {
    margin-top: 8px;
}
.delete-btn {
    margin: 15px 0;
}
</style>